<div
    class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-8 animate-in fade-in slide-in-from-bottom-4 duration-700 tool-layout-container">
    <!-- Header Section -->
    <header class="tool-header mb-8 sm:mb-12" *ngIf="showHeader && (title || description || icon)">
        <div class="icon-main-wrapper inline-flex items-center justify-center p-4 mb-4 rounded-3xl bg-primary/10"
            *ngIf="icon">
            <mat-icon class="!text-4xl sm:!text-5xl text-primary leading-none flex items-center justify-center"
                style="width: 56px; height: 56px; font-size: 56px;">{{ icon }}</mat-icon>
        </div>
        <h1 class="text-3xl sm:text-5xl font-black text-slate-900 dark:text-white tracking-tight leading-tight">
            {{ title }}
        </h1>
        <p
            class="mt-3 sm:mt-4 text-base sm:text-lg text-slate-700 dark:text-slate-300 max-w-2xl mx-auto leading-relaxed font-medium">
            {{ description }}
        </p>
    </header>

    <div class="space-y-6">
        <!-- Toolbar/Actions Area -->
        <div class="actions-toolbar px-4 sm:px-6 py-3 sm:py-4 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 rounded-2xl"
            *ngIf="showCopy || showClear">
            <div class="flex flex-wrap items-center gap-3">
                <ng-content select="[leftActions]"></ng-content>
            </div>

            <div class="flex flex-wrap items-center gap-3 w-full sm:w-auto">
                <ng-content select="[rightActions]"></ng-content>

                <div class="flex items-center gap-3 w-full sm:w-auto">
                    <button *ngIf="showCopy" mat-flat-button color="primary" [disabled]="copyDisabled"
                        (click)="onCopy()" class="action-btn copy-btn flex-1 sm:flex-initial">
                        <mat-icon class="mr-2 !text-[20px]">content_copy</mat-icon>
                        <span>Copy Output</span>
                    </button>
                    <button *ngIf="showClear" mat-stroked-button color="warn" (click)="onClear()"
                        class="action-btn clear-btn flex-1 sm:flex-initial">
                        <mat-icon class="mr-2 !text-[20px]">delete_sweep</mat-icon>
                        <span>Clear All</span>
                    </button>
                </div>
            </div>
        </div>

        <!-- Main Content Area -->
        <main class="tool-main-content">
            <ng-content></ng-content>
        </main>
    </div>

    <!-- Tip/Info Section (Optional via projection) -->
    <footer class="mt-8 sm:mt-12">
        <ng-content select="[footerInfo]"></ng-content>
    </footer>
</div>